import React, { useState, useEffect, useContext } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { UserContext } from '../../context/FormDataContext.js';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input';
import ApiService from '../../classes/ApiService';
import { useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';

const Getstarted = ({buttonClass, buttonText, iconSrc, flag, showJoinWaitList, btn, btnId, onClose}) => {

   


   // const { modalShow, setModalShow } = useContext(UserContext);

 useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("signup") === "beta-program") {
            const modalElement = document.getElementById("exampleModal");
            if (modalElement) {
                if (window.bootstrap && window.bootstrap.Modal) {
                    new window.bootstrap.Modal(modalElement).show();
                }
            }
        }else if(urlParams.get("signup") === "waitlist"){
            handleModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { updateUserFormData, userData } = useContext(UserContext);
    const [isExpanded, setIsExpanded] = useState(false);
        const [showWaitlistAlert, setShowWaitlistAlert] = useState(false);
    const text = `By submitting this form, you consent to Rentid contacting you via SMS, phone, and email for information about our services, promotional offers, and updates. You understand and agree that Rentid may use automated technology including autodialing, AI generated messaging, and AI generated voice to contact you, and that consent is not a condition of purchase. Message frequency may vary, and message/data rates may apply. You can opt out at any time by following the instructions in our communications or by contacting us at contact@rentid.io.`;

    const shortText = text.slice(0, 120) + '...'; // First 160 characters + ellipsis
    const readMoreText = isExpanded ? text : shortText;
    //const [value, setValue] = useState();
    const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().required('Last Name is required'),
        // companyName: Yup.string().required('Company Name is required'),
        phone: Yup.string()
            .required('Phone number is required'),
        // .min(10, 'Phone number must be at least 10 digits'),
        email: Yup.string().email('Email is invalid').required('Email is required'),
        state: Yup.string().required('State is required'),
        fleet: Yup.string().required('Fleet size is required')
    });

    const { register, handleSubmit, formState: { errors }, reset, control } = useForm({
        resolver: yupResolver(validationSchema)
    });


 
    

    const onSubmit = async (data) => {
 
        setLoading(true);
        try {
            const apiService = new ApiService();
            console.log(apiService,'this is apiService')
            // Prepare the form data object
            const formData = {
                first_name: data.firstName,
                last_name: data.lastName,
                company_name: data.companyName,
                phone_number: data.phone,
                email_address: data.email,
                state: data.state,
                fleet_size: data.fleet,
                source: 'waitlist',
                flag: flag ?? null
            };

            console.log(formData,'this is formdata')


            //Call the API to submit the form data
            const response = await apiService.post('/forms/website/beta', formData);

            //Check if the form was submitted successfully
            if(response.success === true){
                updateUserFormData(data.firstName, data.lastName, data.companyName, data.phone, data.email, data.state, data.fleet);
                // Reset the form
                handleClose();
                reset();
                navigate("/beta-signup");
                setLoading(false);
            }else if(response.success === true && response.data?.message){
                setLoading(false);
                //We got a 200 response but with an error message
                console.error('Error submitting form:', response.data.message);
                setErrorMessage(response.data.message);
            }
        } catch (error) {
            if(error.response?.data?.message){
                setLoading(false);
                console.error('Error submitting form:', error.response.data.message);
            }else{
                setLoading(false);  
                console.error('Error submitting form:', error);
            }
        }
    };

    useEffect(() => {
        if (typeof showJoinWaitList === 'boolean') {
          setShow(showJoinWaitList);
        }
      }, [showJoinWaitList]);

    const handleModal = () => {
        //setModalShow(true);
        setShow(!show)
        setTimeout(() => {
            // Refresh selectpicker after modal is rendered
            window.$('.header-state-selectpicker').selectpicker('refresh');
            window.$('.header-fleet-selectpicker').selectpicker('refresh');
        }, 0);

    }
    const handleClose = () => {
        setShow(false);
        //setModalShow(false);
    }

    // useEffect(() => {
    //     if(showJoinWaitList && showJoinWaitList === true){
    //         setShow(showJoinWaitList);
    //     }  
    // }, [showJoinWaitList]);

//    useEffect(() => {
//         if(userData.showJoinWaitList){
//             setShow(userData.showJoinWaitList);
            
//         }
//     }, [userData]);


  return (
    <>
          {btn === true ? <button id={btnId} className={buttonClass} onClick={handleModal} >
              Join the Waitlist
          </button> : <span className={buttonClass} onClick={handleModal} style={{ cursor: "pointer" }}>
              {buttonText} {iconSrc && <img src={iconSrc} alt="Join Waitlist icon" />}
          </span>}


                            <Modal id="waitlist" className='joinlist joinlistPrice'  show={showJoinWaitList} onHide={onClose} centered>
                                <Modal.Header closeButton>
                                     <Modal.Title><span>Sign up</span> for rentid</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Modal.Body> 
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row joinWaitList">
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="first_name">First Name<span className="required">*</span></Form.Label>
                                                            <Form.Control type="text" id="first_name" placeholder='Enter first name' name="waitlist[first_name]" {...register('firstName')}
                                                            defaultValue={userData.firstName}/>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.firstName?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="last_name">Last Name<span className="required">*</span></Form.Label>
                                                            <Form.Control type="text" id="last_name" placeholder='Enter last name' name="lastName" {...register('lastName')}
                                                            defaultValue={userData.lastName}/>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.lastName?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="company_name">Company name (Optional)</Form.Label>
                                                            <Form.Control type="text" id="company_name" placeholder='Enter company name' name="companyName" {...register('companyName')}
                                                            isInvalid={!!errors.companyName} />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.companyName?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="phone_number">
                                                                Phone number<span className="required">*</span>
                                                            </Form.Label>
                                                            <Controller
                                                                name="phone"
                                                                control={control}
                                                                rules={{
                                                                    required: "Phone number is required",
                                                                    validate: (value) => (value && value.length >= 10) || "Phone number must be valid",
                                                                }}
                                                                render={({ field }) => (
                                                                    <PhoneInput
                                                                        {...field}
                                                                        id="phone_number"
                                                                        limitMaxLength={true}
                                                                        defaultCountry="US"
                                                                        placeholder="(XXX) XXX-XXX"
                                                                        onChange={(value) => field.onChange(value)} // Ensure React Hook Form value updates
                                                                        value={field.value || ''}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.phone && (
                                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                                    {errors.phone.message}
                                                                </Form.Control.Feedback>
                                                            )}
                                                        </Form.Group>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="email_address">Email address<span className="required">*</span></Form.Label>
                                                            <Form.Control type="email" id="email_address" placeholder='Enter your email' name="email" {...register('email')}
                                                                isInvalid={!!errors.email} />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.email?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="state">State<span className="required">*</span></Form.Label>
                                                            <Form.Select id="state" className="header-state-selectpicker" name="state" data-live-search="true" {...register('state')} isInvalid={!!errors.state}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value='Alabama'>Alabama</option>
                                                                <option value='Alaska'>Alaska</option>
                                                                <option value='Arizona'>Arizona</option>
                                                                <option value='Arkansas'>Arkansas</option>
                                                                <option value='California'>California</option>
                                                                <option value='Colorado'>Colorado</option>
                                                                <option value='Connecticut'>Connecticut</option>
                                                                <option value='Delaware'>Delaware</option>
                                                                <option value='Florida'>Florida</option>
                                                                <option value='Georgia'>Georgia</option>
                                                                <option value='Hawaii'>Hawaii</option>
                                                                <option value='Idaho'>Idaho</option>
                                                                <option value='Illinois'>Illinois</option>
                                                                <option value='Indiana'>Indiana</option>
                                                                <option value='Iowa'>Iowa</option>
                                                                <option value='Kansas'>Kansas</option>
                                                                <option value='Kentucky'>Kentucky</option>
                                                                <option value='Louisiana'>Louisiana</option>
                                                                <option value='Maine'>Maine</option>
                                                                <option value='Maryland'>Maryland</option>
                                                                <option value='Massachusetts'>Massachusetts</option>
                                                                <option value='Michigan'>Michigan</option>
                                                                <option value='Minnesota'>Minnesota</option>
                                                                <option value='Mississippi'>Mississippi</option>
                                                                <option value='Missouri'>Missouri</option>
                                                                <option value='Montana'>Montana</option>
                                                                <option value='Nebraska'>Nebraska</option>
                                                                <option value='Nevada'>Nevada</option>
                                                                <option value='New Hampshire'>New Hampshire</option>
                                                                <option value='New Jersey'>New Jersey</option>
                                                                <option value='New Mexico'>New Mexico</option>
                                                                <option value='New York'>New York</option>
                                                                <option value='North Carolina'>North Carolina</option>
                                                                <option value='North Dakota'>North Dakota</option>
                                                                <option value='Ohio'>Ohio</option>
                                                                <option value='Oklahoma'>Oklahoma</option>
                                                                <option value='Oregon'>Oregon</option>
                                                                <option value='Pennsylvania'>Pennsylvania</option>
                                                                <option value='Rhode Island'>Rhode Island</option>
                                                                <option value='South Carolina'>South Carolina</option>
                                                                <option value='South Dakota'>South Dakota</option>
                                                                <option value='Tennessee'>Tennessee</option>
                                                                <option value='Texas'>Texas</option>
                                                                <option value='Utah'>Utah</option>
                                                                <option value='Vermont'>Vermont</option>
                                                                <option value='Virginia'>Virginia</option>
                                                                <option value='Washington'>Washington</option>
                                                                <option value='West Virginia'>West Virginia</option>
                                                                <option value='Wisconsin'>Wisconsin</option>
                                                                <option value='Wyoming'>Wyoming</option>

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.state?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    {/* <div className="col-md-6 select_3">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label htmlFor="fleet_size">Fleet size</Form.Label>
                                                            <Form.Select id="fleet_size" className="header-fleet-selectpicker" name="fleet" {...register('fleet')} isInvalid={!!errors.fleet}>
                                                                <option value="">Select</option>
                                                                <option value="1">1</option>
                                                                <option value="2 to 5">2 to 5</option>
                                                                <option value="5 to 10">5 to 10</option>
                                                                <option value="Greater than 10">Greater than 10</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.fleet?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div> */}
                                                      <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                        <Form.Label htmlFor="fleet_size">Fleet size</Form.Label>
                                                            <Form.Control type="number" id="fleet_size" placeholder='' name="fleet" {...register('fleet')}
                                                                isInvalid={!!errors.fleet}  />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.fleet?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                                                            </div>
                                                    <p className='mb-0 disclaimer'>{readMoreText} <span onClick={() => setIsExpanded(!isExpanded)}>
                                                        {isExpanded ? 'Read Less' : 'Read More'}
                                                    </span></p>

                                                    <p className="mt-3 mb-0 d-flex align-items-start">
                                                        <input type="checkbox" id="privacy-checkbox" className="me-2" required />
                                                        <label htmlFor="privacy-checkbox" className="me-2">
                                                            I consent to receiving communications from Rentid via email, phone call, and SMS, including with the use of AI and automated dialing technologies, and I agree to Rentid’s <a href="terms" target="_blank" className="text-white">Terms of Service</a> and <a href="privacy" target="_blank" className="text-white">Privacy Policy</a>.
                                                        </label>

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Alert show={showWaitlistAlert} key={'header-waitlist-form-alert'} variant={'danger'} onClose={() => setShowWaitlistAlert(false)} dismissible>
                                            {errorMessage}
                                        </Alert>
                                        <Button type="submit" className='joinbtn' variant="primary">
                                          Submit
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                                    </Modal>
    </>
  )
}

export default Getstarted
